import React from 'react'
import {
  getUrl,
} from 'utils/storage'

const isImage = (data) => {
  if(!data) return false
  if(data.type.indexOf('image') == 0) return true
  if(data.filename.match(/\.{jpg,png,jpeg,gif}$/i)) return true
  return false
}

const Image = ({
  data,
  className,
}) => {
  if(!isImage(data)) return null
  return (
    <img className={ className } src={ getUrl(data.filepath) } />
  )
}

export default Image
